import { render, staticRenderFns } from "./DamageAndMissing.vue?vue&type=template&id=32499844&"
import script from "./DamageAndMissing.vue?vue&type=script&lang=js&"
export * from "./DamageAndMissing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports